// The theme's web fonts ship in the bundle rather than coming from Google at runtime.
import '@fontsource/lato/400.css'
import '@fontsource/lato/700.css'
import '@fontsource/lato/900.css'
import '@fontsource/yantramanav/400.css'
import '@fontsource/yantramanav/500.css'
import '@fontsource/yantramanav/700.css'
import AppProviders from '@/providers/AppProviders'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { flushPendingEvents } from './lib/analytics'

flushPendingEvents()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
	<React.StrictMode>
		<AppProviders>
			<App />
		</AppProviders>
	</React.StrictMode>,
)
